import type { UserRole } from "@clinica/shared-types";

export type AccessTokenClaims = { sub: string; role: UserRole; alsoAdmin: boolean };

const VALID_ROLES: UserRole[] = ["ADMIN", "SECRETARY", "PROFESSIONAL"];

/**
 * Decodifica o payload de um JWT sem verificar a assinatura — só para uso
 * de UI (esconder itens de menu). A garantia real de autorização continua
 * inteiramente no backend via `requireRole` (apps/api/src/plugins/rbac.ts).
 */
export function decodeAccessTokenClaims(token: string): AccessTokenClaims | null {
  try {
    const payload = token.split(".")[1];
    if (!payload) return null;

    const base64 = payload.replace(/-/g, "+").replace(/_/g, "/");
    const padded = base64 + "=".repeat((4 - (base64.length % 4)) % 4);
    const parsed = JSON.parse(atob(padded)) as { sub?: unknown; role?: unknown; alsoAdmin?: unknown };

    if (typeof parsed.sub !== "string") return null;
    if (typeof parsed.role !== "string" || !VALID_ROLES.includes(parsed.role as UserRole)) return null;

    return {
      sub: parsed.sub,
      role: parsed.role as UserRole,
      alsoAdmin: typeof parsed.alsoAdmin === "boolean" ? parsed.alsoAdmin : false,
    };
  } catch {
    return null;
  }
}
